exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".training-project-session-logs-list {\n  font-size: 12px;\n  line-height: 1.6;\n  background: #0b0c0d;\n  color: #d6d8db;\n  padding: 12px 14px;\n  border-radius: 4px;\n  height: calc(100vh - 370px);\n  overflow-y: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.training-project-session-logs-list .log-line {\n  padding: 1px 0;\n}\n", ""]);

// exports
